/*

  This component will lazy load a module component when it is to be rendered

*/

import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import { BubblesLoader, BackButton } from "ksc-portal-common-components/atoms"

class AsyncUserSettings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      Component: null,
      Stylesheet: null,
      name: "",
    }
  }

  componentDidMount() {
    const { moduleProvider, replaceSidebar = () => null } = this.props
    moduleProvider
      /* eslint-disable-next-line */
      .then(({ Component, name, ApiStage, Sidebar, Stylesheet, ...rest }) => {
        this.setState({ Stylesheet, Component, name })
        replaceSidebar({
          sidebar: Sidebar,
          name: `${name}-${Sidebar ? "sidebar" : "-invalid-class"}`,
        })
      })
      .catch(console.error)
  }

  render() {
    const { history } = this.props
    const { Component, Stylesheet, name } = this.state
    return (
      <>
        {" "}
        {Stylesheet && <link rel="stylesheet" href={Stylesheet} />}
        {Component ? (
          <div id={name}>
            <div className="portal-user-settings-module-container__back-button">
              <BackButton onClick={() => history.push("/user-settings")} />
            </div>
            <Component />
          </div>
        ) : (
          <BubblesLoader />
        )}{" "}
      </>
    )
  }
}

AsyncUserSettings.propTypes = {
  moduleProvider: PropTypes.shape({
    then: PropTypes.func,
  }),
  replaceSidebar: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
}

AsyncUserSettings.defaultProps = {
  moduleProvider: {},
  replaceSidebar: undefined,
}

export default AsyncUserSettings
